import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-color",
  "use": "icon-color-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-color\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M12,6c3.31,0,6,2.39,6,5.33a3.34,3.34,0,0,1-3.33,3.34H13.49a1,1,0,0,0-1,1,1,1,0,0,0,.25.66A1,1,0,0,1,12,18,6,6,0,0,1,12,6ZM9.3,12a.9.9,0,1,0-.9-.9A.9.9,0,0,0,9.3,12Zm5.4,0a.9.9,0,1,0-.9-.9A.9.9,0,0,0,14.7,12ZM12,10.2a.9.9,0,1,0-.9-.9A.9.9,0,0,0,12,10.2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol